import MovimientosSnapshot from "./MovimientosSnapshot";
export default MovimientosSnapshot;
